import { lazy } from 'react';

const BetMarking = lazy(() => import('features/staticPages/container/betMarkings'));
const Privacy = lazy(() => import('features/staticPages/container/privacy'));
const Contact = lazy(() => import('features/staticPages/container/contact'));
const Payment = lazy(() => import('features/staticPages/container/payment'));

const HomeWrapper = lazy(() => import('features/Home/HomeWrapper.component'));
const Live = lazy(() => import('features/live/container/live'));
const Sport = lazy(() => import('features/sports/container/sport'));
const Promotion = lazy(() => import('features/promotion/container/promotion'));
const PromotionDetails = lazy(() => import('features/promotion/component/promotionDetails'));
const Entertainment = lazy(() => import('features/entertainment/container/entertainment'));
const PreMatch = lazy(() => import('features/eventPreMatch/container/sportPrematch'));
const EventLive = lazy(() => import('features/eventLive/container/eventLive'));
const ESSport = lazy(() => import('features/esSport/container/esSport'));
const CategorySport = lazy(() => import('features/sports/container/firstCategorySport'));
const EventLiveDetail = lazy(() => import('features/eventLive/container/eventLive'));
const TodaysOffer = lazy(() => import('features/todaysOffer/container/todaysOffer'));
const CardGames = lazy(() => import('features/cardGames/container/cardGames'));
const SecondCategorySport = lazy(() => import('features/sports/container/secondLevelCategorySport'));
const SportCategories = lazy(() => import('features/sports/container/sportsCategory'));

const Coupons = lazy(() => import('features/CouponsPage'));
const VirtualSports = lazy(() => import('features/virtualSports/container/virtualSports'));

const Login = lazy(() => import('features/login/container/login'));
const ActivateAccount = lazy(() => import('features/login/container/activateAccount'));
const Registration = lazy(() => import('features/registration/container'));
const RegistrationMethod = lazy(() => import('features/auth/ABTestRegistration'));
const VerificationMethod = lazy(() => import('features/auth/ABTestVerification'));
const RegistrationMojeId = lazy(() => import('features/auth/registrationMojeId/RegistrationMojeId'));
const VerificationMojeIdAuthWrapper = lazy(() => import('features/auth/verificationMojeId/VerificationMojeIdAuthWrapper'));
const ForgotPassword = lazy(() => import('features/forgotPass/container/forgotPass'));
const MyBet = lazy(() => import('features/myBet/container/myBet'));

const Deposit = lazy(() => import('features/deposit/container'));
const CustomPageDetails = lazy(() => import('features/customPage/component/customPageDetails'));

const KuponKibica = lazy(() => import('features/kupon-kibica/kupon-kibica'));
const Map = lazy(() => import('features/mapPage/container/index'));
const ShareKuponKibica = lazy(() => import('features/coupon/component/CouponShareDialog/CouponShareDialog'));
const BetMatch = lazy(() => import('features/betMatch'));
const PlayerProfile = lazy(() => import('features/customerPanel/cpPlayerProfile/container'));
const Medals = lazy(() => import('features/customerPanel/cpPlayerProfile/component/medals/Medals'));
const Special = lazy(() => import('features/special'));
const DailyChallenge = lazy(() => import('features/dailyChallenge'));
const Regulations = lazy(() => import('features/staticPages/container/regulations'));
const VipContactPage = lazy(() => import('features/staticPages/container/vipContact/vipContact'));

export {
	CustomPageDetails,
	Login,
	Registration,
	RegistrationMethod,
	VerificationMethod,
	RegistrationMojeId,
	VerificationMojeIdAuthWrapper,
	ForgotPassword,
	HomeWrapper,
	Live,
	Sport,
	Promotion,
	PromotionDetails,
	BetMarking,
	Privacy,
	Contact,
	Payment,
	Coupons,
	Entertainment,
	PreMatch,
	EventLive,
	ESSport,
	CategorySport,
	EventLiveDetail,
	TodaysOffer,
	CardGames,
	VirtualSports,
	SecondCategorySport,
	SportCategories,
	// UsefulLinks,
	MyBet,
	KuponKibica,
	ShareKuponKibica,
	ActivateAccount,
	Map,
	BetMatch,
	PlayerProfile,
	Medals,
	Special,
	DailyChallenge,
	Regulations,
	VipContactPage,
	Deposit,
};
